import React from "react";

export default function UnderConstruction() {
  return (
    <div
      data-testid="under-construction-page"
      className="min-h-screen w-full flex flex-col items-center justify-center px-6 py-16 bg-[#F5F0E4] text-[#2A3B2C] relative overflow-hidden"
    >
      {/* Soft grain / texture layer */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, #2A3B2C 1px, transparent 1px), radial-gradient(circle at 80% 60%, #D95D39 1px, transparent 1px)",
          backgroundSize: "28px 28px, 40px 40px",
        }}
      />

      <div className="relative z-10 flex flex-col items-center text-center max-w-lg">
        <div
          className="w-28 h-28 sm:w-36 sm:h-36 rounded-3xl bg-white border border-[#E5E1D8] flex items-center justify-center shadow-lg overflow-hidden mb-8"
          data-testid="under-construction-logo"
        >
          <img
            src="/alkoncierge-logo.png"
            alt="AlKoncierge"
            className="w-20 h-20 sm:w-28 sm:h-28 object-contain"
            draggable="false"
          />
        </div>

        <div className="font-display font-semibold text-4xl sm:text-5xl lg:text-6xl mb-3 tracking-tight">
          <span className="text-[#D95D39]">Al</span>Koncierge
        </div>

        <div className="text-[11px] sm:text-xs uppercase tracking-[0.28em] font-bold text-[#8A9A8B] mb-10">
          Eat halal · anywhere
        </div>

        <div
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#E5E1D8] bg-white/70 backdrop-blur-sm text-[11px] uppercase tracking-[0.24em] font-semibold text-[#8A9A8B] mb-6"
          data-testid="under-construction-badge"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-[#D95D39] animate-pulse" />
          Coming soon
        </div>

        <h1
          className="font-display font-semibold text-2xl sm:text-3xl text-[#2A3B2C]"
          data-testid="under-construction-heading"
        >
          Under Construction
        </h1>
      </div>
    </div>
  );
}
